module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ofxLL6/tc-custom/9781451625271.jpg?1718106016457",
      "alt": "This image is the cover for the book In His Own Write"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("In His Own Write\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("AN OMNIBUS EDITION OF JOHN LENNON’ S ")]), _c('b', [_vm._v("WHIMSICAL POETRY, PROSE, AND DRAWINGS, ")]), _c('b', [_vm._v("REISSUED IN CELEBRATION OF THE ")]), _c('b', [_vm._v("70TH ANNIVERSARY OF HIS BIRTH. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Lennon, Yoko Ono\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Best known as singer-songwriter for the legendary Beatles, John Lennon was born in Liverpool, England. In 1969, Lennon married Yoko Ono and the two formed the Plastic Ono Band. Lennon was killed by a deranged fan outside his apartment building in New York on December 8, 1980.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Simon & Schuster\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0